import { ApiClient } from 'app/service/api-service'
import { AuthEndPoint } from './constant'
import {
  IPayloadNewPassword,
  LoginRequest,
  LoginWithTokenRequest,
  ResetPasswordRequest,
  SecurityCodePayload,
  SignUpRequest,
} from './model'

export const requestPostLogin = (body: LoginRequest) =>
  ApiClient.Post({ url: AuthEndPoint.LOGIN, body })

export const requestPostLoginWithToken = (body: LoginWithTokenRequest) =>
  ApiClient.Post({ url: AuthEndPoint.LOGIN_WITH_TOKEN, body })

export const requestPostSignUp = (body: SignUpRequest) =>
  ApiClient.Post({ url: AuthEndPoint.SIGN_UP, body })

export const requestPostResetPassword = (body: ResetPasswordRequest) =>
  ApiClient.Post({ url: AuthEndPoint.FORGOT_PASSWORD, body })

export const requestPostVerifySecurityCode = (body: SecurityCodePayload) =>
  ApiClient.Post({
    url: AuthEndPoint.VERITY_CODE,
    body,
  })

export const requestSetNewPassword = (body: IPayloadNewPassword) =>
  ApiClient.Put({ url: AuthEndPoint.NEW_PASSWORD, body })
